import React, { useContext, useState } from "react";
import { withTools } from "../../../../helper/withTools";
import FuncionesContext from "../../../../context/FuncionesContext";
import ModalesContext from "../../../../context/ModalContext";
import TextField from "@mui/material/TextField";
import Label from "../LabelF";

const InputBuscador = (props) => {
  const {
    id,
    id_a,
    setFiltrosAAplicar,
    error,
    setError,
    seleccion_multiple,
    columna_ida_valor,
    columna_ida_mostrar,
    filtro_ida_valor,
    pantalla_ida,
    cab,
  } = props;

  const [termino, setTermino] = useState("");
  const [oid, setId] = useState("");

  const handleInput = (e) => {
    const { value } = e.target;
    setTermino(value);
    setFiltrosAAplicar((prevState) => {
      const clave = props.clave_envio;
      const newState = { ...prevState, [id_a]: undefined };
    
      if (clave) {
        newState[clave] = undefined;
      }
    
      return newState;
    });
    setId("");
  };

  const { enviarAModal } = useContext(FuncionesContext);
  const { cerrarModal } = useContext(ModalesContext);

  const filtro = {
    [filtro_ida_valor]: termino, // filtro id_a a pasar al listado "MONODRO_LST_FILTRO_NOMBRE"
  };

  const opMultiple = {
    listado_seleccion: true,
    showSelectAllCheckbox: false,
    showTextRowsSelected: false,
    onSelectionChange: (e) => {
      const noid = e.map((o) => o[columna_ida_valor]); // columna a setear como value "MONODRO_LST_ID"
      setTermino(e.map((t) => t[columna_ida_mostrar]).toString()); // columnda a mostrar "MONODRO_LST_NOMBRE"
      setFiltrosAAplicar((prevState) => {
        const clave = props.clave_envio;
        const newState = { ...prevState, [id_a]: noid };
      
        if (clave) {
          newState[clave] = noid;
        }
      
        return newState;
      });
      setError((e) => {
        return { ...e, [id_a]: false };
      });
      setId(noid);
    },
    listado_filtro_termino: termino,
    filtrosDesdeInput: filtro,
    activarListado: !!termino,
    min_width_modal: cab.min_width_modal,
  };

  const opSimple = {
    onRowClick: (e, rowData, data) => {
      const noid = rowData[columna_ida_valor]; // columna a setear como value
      setTermino(rowData[columna_ida_mostrar]); // columnda a mostrar
      setId(noid);
      setFiltrosAAplicar((prevState) => {
        const clave = props.clave_envio;
        const newState = { ...prevState, [id_a]: noid };
      
        if (clave) {
          newState[clave] = noid;
        }
      
        return newState;
      });
      setError((e) => {
        return { ...e, [id_a]: false };
      });
    },
    onRowDoubleClick: (e, rowData) => {
      const noid = rowData[columna_ida_valor]; // columna a setear como value
      setTermino(rowData[columna_ida_mostrar]); // columnda a mostrar
      setId(noid);
      setFiltrosAAplicar((prevState) => {
        const clave = props.clave_envio;
        const newState = { ...prevState, [id_a]: noid };
      
        if (clave) {
          newState[clave] = noid;
        }
      
        return newState;
      });
      setError((e) => {
        return { ...e, [id_a]: false };
      });
      cerrarModal(pantalla_ida);
    },
    rowStyle: true,
    listado_filtro_termino: termino,
    filtrosDesdeInput: filtro,
    activarListado: !!termino,
    min_width_modal: cab.min_width_modal,
  };

  const showModal = () =>
    enviarAModal(
      pantalla_ida, // Listado para abrir "PANTALLA_LIST_MONODRO"
      {},
      seleccion_multiple === "s" ? opMultiple : opSimple
    );

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      showModal();
    }
  };

  return (
    <div id={id_a}>
      <Label
        label={props.nombre}
        opcionales_null={props.opcionales_null}
        permite_null={props.permite_null}
      />

      <div className="filtroBuscador">
        <TextField
          onChange={handleInput}
          onKeyDown={handleKeyDown}
          id={id}
          value={termino}
          style={{ width: "82%", padding: "0 0", marginRight: "6px" }}
          type="text"
          error={error[id_a]}
          // variant="outlined"
          label={props.label}
        />
        <button
          onClick={() => showModal()}
          style={{
            padding: "0.23rem",
            backgroundColor: "#006F7A",
            color: "white",
            width: "15%",
            height: "100%",
          }}
          className="InputBusquedaLupa"
        >
          <i class="fa fa-search" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  );
};

export default withTools(InputBuscador);
